export default __webpack_public_path__ + "static/programming-65682c9f486114aac30dbfd765707d48.svg";